import { FC } from 'react';
import UserIcon from 'assets/user.svg';
import FavoriteIcon from 'assets/favoriteOffIcon.svg';
import LogOutIcon from 'assets/log-out.svg';
import {
  LinkDropdown,
  LinkDropdownData,
} from 'components/DsDropdown/LinkDropdown';
import { useTranslation } from 'hooks/useTranslation';
import { useUILanguage } from 'hooks/useUILanguage';
import { useLogOutAction } from 'components/Controls/Control/actions/useLogOutAction';
import { UserInitials } from 'components/UserInitials/UserInitials';
import { useAreenaService } from 'contexts/AreenaServiceContext';
import { Language, Service } from '@yleisradio/areena-types';
import {
  personalPodcastRoutes,
  personalRoutes,
  personalTVRoutes,
} from 'utils/routes';

function getPersonalUri(
  areenaService: Service | undefined,
  language: Language
): string {
  if (!areenaService) return `/${personalRoutes[language]}`;

  const personalUrl =
    areenaService === 'tv'
      ? personalTVRoutes[language]
      : personalPodcastRoutes[language];

  return `/${personalUrl}`;
}

const UserDropdown: FC = () => {
  const t = useTranslation();
  const language = useUILanguage();
  const logOutAction = useLogOutAction();
  const { areenaService } = useAreenaService();

  const data: LinkDropdownData[] = [
    {
      Icon: FavoriteIcon,
      label: t('ownPage'),
      pointer: {
        uri: getPersonalUri(areenaService, language),
      },
    },
    {
      Icon: UserIcon,
      label: t('personalInfo'),
      pointer: {
        uri:
          language === 'fi'
            ? 'https://tunnus.yle.fi/omat-tiedot'
            : 'https://tunnus.yle.fi/mina-uppgifter',
      },
    },
    {
      Icon: LogOutIcon,
      label: t('logOut'),
      handleOnClick: () => {
        logOutAction?.runAction();
      },
      testId: 'logout',
    },
  ];

  return (
    <LinkDropdown
      TriggerIcon={() => <UserInitials />}
      data={data}
      size={'md'}
      triggerAriaLabel={t('profile')}
      triggerTestId="user-dropdown-trigger"
    />
  );
};

export { UserDropdown };
